export default __webpack_public_path__ + "static/media/art_transparent.527fa6f1.png";